import Phaser from 'phaser'

const heroEvents = new Phaser.Events.EventEmitter()

export {
	heroEvents
}
